import { ComponentTransitionMaping, PPSTransitionRecord } from "@/services/project/PPSTransition.service"
import { getPropertySets } from "@/store/project/project.slice"
import { Modal, Select } from "antd"
import { useMemo, useState } from "react"
import { useSelector } from "react-redux"

interface MapModalProps {
  record: PPSTransitionRecord
  value: ComponentTransitionMaping[]
  onChange?: (mapChanges: ComponentTransitionMaping[]) => void
  onCancel?: () => void
}

export const MapModal = (props: MapModalProps) => {
  const {record, value: initVal, onChange, onCancel} = props;
  const propertySets = useSelector(getPropertySets)
  const [value, setValue] = useState(initVal || [])

  const data = useMemo(() => {
    const {pps, inletPps} = record;
    let inletName = inletPps
    let outletName = pps
    const inletPPS = propertySets.find(item => item.name === inletName)
    const outletPPS = propertySets.find(item => item.name === outletName)
    const outComponents = outletPPS?.components || []
    return {
      inComponents: inletPPS?.components || [],
      outComponents: outComponents,
      outOptions: outComponents.map(item => {
        return {
          label: item.name,
          value: item.id
        }
      })
    }
  }, [record, value, propertySets])

  const onSelectChange = (val, index) => {
    const target = value[index];
    if (!target) {
      value[index] = {
        in: data.inComponents[index].id,
        out: val
      }
    } else {
      value[index].out = val
    }
    setValue([...value])
  }

  const onSave = () => {
    const formatVal = data.inComponents.map((item, index) => {
      return {
        in: item.id,
        out: value[index]?.out
      }
    })
    onChange?.(formatVal)
  }

  return <Modal width={600} open={true} title="Map" onOk={onSave} onCancel={onCancel} onClose={onCancel}>
    <table style={{width: '100%'}} className="bordered-table break-word-table">
      <thead>
        <tr>
          <th style={{width: '50%'}}>Outlet Port Components</th>
          <th style={{width: '50%'}}>Inlet Port Components</th>
        </tr>
      </thead>
      <tbody>
        {data.inComponents.map((component, index) => {
          return <tr>
            <td>{component.name}</td>
            <td><Select
              style={{width: '100%'}}
              options={data.outOptions}
              value={value[index]?.out}
              onChange={(val) => onSelectChange(val, index)}/></td>
          </tr>
        })}
      </tbody>
    </table>
  </Modal>
}